var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.732,
    height: 17.242,
    viewBox: "0 0 24.732 17.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#91acb8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.456,7C7.64,7,3.875,13.964,3.09,15.621c.785,1.705,4.483,8.621,12.366,8.621,7.816,0,11.581-6.964,12.366-8.621C27.037,13.916,23.339,7,15.456,7Zm0,13.41a4.789,4.789,0,1,1,4.789-4.789A4.791,4.791,0,0,1,15.456,20.41Z",
    transform: "translate(-3.09 -7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.66aa2d89195e4fb4b31a10285761826d.svg";
export { ForwardRef as ReactComponent };